import React from 'react';
import { SLIDER_CLASS } from './PortalSlider';

interface DetailsHeaderOptions {
  onClose?: () => void;
  onOpenInNewWindowClick?: () => void;
  title?: string;
}

export function SliderHeader({ onClose, onOpenInNewWindowClick, title }: DetailsHeaderOptions) {
  return (
    <header className={`${SLIDER_CLASS}__header`}>
      <button className={`${SLIDER_CLASS}__close`} onClick={onClose}></button>
      <div className={`${SLIDER_CLASS}__title`} title={title}>{title}</div>
      {onOpenInNewWindowClick && (
        <button className={`${SLIDER_CLASS}__open-new-window`} onClick={onOpenInNewWindowClick}>
          Open in new window
        </button>
      )}
    </header>
  );
}
